import React from 'react';
import ReactTooltip from 'react-tooltip'
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ApplicationState } from '../../store';

//component state
interface IStateProps {

}

//component props
interface IOwnProps {

}

//redux state props
interface IReduxStateProps {

}

interface IReduxDispatchProps {

}

type Props = IOwnProps & IReduxStateProps & IReduxDispatchProps & WithTranslation;

class PriceIsNotFinal extends React.PureComponent<Props, IStateProps> {

    render() {

        return <React.Fragment>
            <span className="priceMultiRow" data-tip data-for="priceIsNotFinal">
                { this.props.t( 'product.priceIsNotFinal.label' ) } <i className="glyphicon glyphicon-question-sign"></i>
            </span>
            <ReactTooltip id='priceIsNotFinal' place="bottom" type="dark" effect="solid">
                <div className="tip">{ this.props.t( 'product.priceIsNotFinal.tooltip' ) }</div>
            </ReactTooltip>
        </React.Fragment>;
    }
}

const mapStateToProps = ( state: ApplicationState ): IReduxStateProps => ( {

} );

const mapDispatchToProps = ( dispatch: Function ): IReduxDispatchProps => ( {

} );

export default connect<IReduxStateProps, IReduxDispatchProps, IOwnProps, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps
)( withTranslation()( PriceIsNotFinal ) );
